import { detectPortal, Portal } from './common/util/detect-portal';

const portal = detectPortal();

if (portal === Portal.SPP) {
    const { bootstrap } = await import('./spp/bootstrap');
    await bootstrap();
} else {
    const { bootstrap } = await import('./cpp/bootstrap');
    await bootstrap();
}
